import { CliError } from "@/lib/cli/cli-error";

/** Unset means forever: only a caller with no Ctrl-C needs an exit code. */
export function resolveFollowOutageBudget(): number | null {
  const raw = process.env.HEPHA_FOLLOW_MAX_OUTAGE_SECONDS?.trim();
  if (!raw) {
    return null;
  }
  // Checked in milliseconds: a finite 1e306 seconds overflows to an Infinity
  // budget, which would silently never expire.
  const budgetMs = Number(raw) * 1_000;
  if (!Number.isFinite(budgetMs) || budgetMs <= 0) {
    throw new CliError(
      `HEPHA_FOLLOW_MAX_OUTAGE_SECONDS expects a positive number of seconds, got "${raw}".`,
      2,
    );
  }
  return budgetMs;
}
